/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByConversationCategoryKind =
  (typeof GroupByConversationCategoryKind)[keyof typeof GroupByConversationCategoryKind];

export const GroupByConversationCategoryKind = {
  conversation_category: 'conversation_category',
} as const;
